import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { menuMobx } from 'restaurant'
import { recommendMobx, themeMobx } from '@mobxStore'
import { ClassicSkeleton, Empty } from '@cps'
import ProductList from '../ProductList'
import CategoryBar from '../CategoryBar'
import './index.scss'

import noMealImg from '@img/no-meal.png'

const ClassicTemplate: FC = () => {
  return (
    <div className='classic-template'>
      {
        menuMobx.isLoading ? <ClassicSkeleton /> : recommendMobx.categories.length ? (
          <>
            <CategoryBar />
            <ProductList type='classic' />
          </>
        ) : ( // 无餐品
          <Empty
            msg={themeMobx?.data?.abnormalStateSetting?.[0]?.subName || ''}
            iconType='dicon'
            iconName={themeMobx?.data?.abnormalStateSetting[0]?.icon}
            picUrl={themeMobx?.data?.abnormalStateSetting[0]?.pic || noMealImg}
            height='55vh'
          />
        )
      }
    </div>
  )
}

export default observer(ClassicTemplate)
